import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../store";
import { useMemo } from "react";
import _ from "lodash";
import { getFullName } from "../../../../../../utils/NamesUtils";
import {
  BasicUserInfo,
  EvidenceColumnGroup,
  EvidencePeriodData,
  EvidenceType,
  MeasurementType,
  Student,
  StudentRow,
} from "../../../../../../store/onboarding/types";
import { Grade } from "../../../../../../store/groups/types";

const BREAKPOINT = 0.5;

type ClassWideNeed = {
  self_awareness: SkillAreaStats,
  self_management: SkillAreaStats,
  social_awareness: SkillAreaStats,
  relationship_skills: SkillAreaStats,
  goal_directed_behavior: SkillAreaStats,
  personal_responsibility: SkillAreaStats,
  decision_making: SkillAreaStats,
  optimistic_thinking: SkillAreaStats
};

type SkillAreaStats = {
  studentsIds: number[];
  skills: SkillStat[];
};

type SkillStat = {
  studentIds: number[];
  skill_focus: string;
  display_name: string;
};
export type ClassWideNeedsStats = {
  classWideNeed: Record<string, SkillAreaStats>;
  grade?: string;
  classInfo?: string;
  teacher: BasicUserInfo;
  students: Student[];
};

export type evidenceColumnGroup = {
    teacher: BasicUserInfo;
    grade: Grade | undefined;
    students: Student[];
    classInfo: string;
}

const SkillAreaGroup: { [key: string]: string } = {
  //dessa
  self_awareness: "self_awareness",
  self_management: "self_management",
  social_awareness: "social_awareness",
  relationship_skills: "relationship_skills",
  goal_directed_behavior: "goal_directed_behavior",
  personal_responsibility: "personal_responsibility",
  decision_making: "decision_making",
  optimistic_thinking: "optimistic_thinking"
};

const useBehaviourClassWideNeeds = () => {
  let fullEvidenceInDataPeriodInfo = useSelector(
    (s: ApplicationState) => {
      if(s.onboarding.fullEvidenceInDataPeriod?.student_rows.length! > 3000) {
        let fullEvidenceInDataPeriodInfo = s.onboarding.fullEvidenceInDataPeriod;
        let topStudentRows = fullEvidenceInDataPeriodInfo?.student_rows.slice(0, 3000);
          fullEvidenceInDataPeriodInfo = {
            ...fullEvidenceInDataPeriodInfo!,
            student_rows: topStudentRows!
          }

        for (let i = 0; i < fullEvidenceInDataPeriodInfo?.evidence_column_groups.length!; i++) {
          const ecg = fullEvidenceInDataPeriodInfo?.evidence_column_groups[i];
          for (let j = 0; j < ecg?.evidence_columns.length!; j++) {
            let ec = ecg?.evidence_columns[j];
            ec.student_entries = ec?.student_entries.filter((ec) => topStudentRows?.some((tsr) => tsr.student.id == ec.student_id));
            ecg.evidence_columns[j] = ec;
          }
        }
        return fullEvidenceInDataPeriodInfo;
      } else {
        return s.onboarding.fullEvidenceInDataPeriod
      }
    }
  );

  const currentDataPeriod = useSelector(
    (s: ApplicationState) => s.onboarding.currentDataPeriod
  );

  const timePeriod = useMemo(() => {
    return currentDataPeriod?.time_period;
  }, [currentDataPeriod?.time_period]);
  
  // evidencePeriodData?.evidence_column_groups.map((evidenceColumnGroup)=> 
  //   evidenceColumnGroup.evidence_columns.map((ecg)=> {
  //     if((ecg.measurement != null) && ecg.measurement.skill_areas?.length == 0) { //only for dessa
  //       if(!ecg.measurement.known_assessment!.includes('percentile')){
  //         ecg.measurement.skill_areas.push(ecg.measurement.known_assessment!)
  //       }
  //     }
  //     return ecg;
  //   })
  // )  

  let classWideNeedsData: EvidencePeriodData | undefined = _.cloneDeep(fullEvidenceInDataPeriodInfo);

  classWideNeedsData = useMemo(() => {
    if(fullEvidenceInDataPeriodInfo) {
      for (let i = 0; i < fullEvidenceInDataPeriodInfo?.evidence_column_groups.length; i++) {
        const ecg = fullEvidenceInDataPeriodInfo?.evidence_column_groups[i];
        for (let j = 0; j < ecg!.evidence_columns.length; j++) {
          const ec = ecg!.evidence_columns[j];
          for (let k = 0; k < ec.student_entries.length; k++) {
            fullEvidenceInDataPeriodInfo?.student_rows.map((studentRow) =>{
              if(studentRow.student.id === ec.student_entries[k].student_id) {
                studentRow.student.teachers?.filter((teacher)=> {
                  if(teacher.classes == null) {
                    return teacher.classes = [];
                  }
                })
                .map((teacher: BasicUserInfo) => (teacher.classes?.length) ? teacher.classes : teacher.classes?.push({id:0, name: 'Unassigned'}))
                studentRow.grade = ec.student_entries[k].grade;
                return studentRow;
              }
            })
          }
        }
      }
    }
    return fullEvidenceInDataPeriodInfo;

  },[fullEvidenceInDataPeriodInfo])

  let evidenceGroups: evidenceColumnGroup[] = useMemo(() => {
    if (classWideNeedsData?.student_rows.length) {
      let studentGroupRow =  _.chain(classWideNeedsData.student_rows)
        .flatMap((studentRow) =>
          (studentRow.student.teachers || []).flatMap((teacher) => (teacher.classes || []).map((classInfo) => ({
            teacher: teacher,
            grade: studentRow.grade,
            student: studentRow.student,
            classInfo: classInfo.name == 'Unassigned' ? `Unassigned-${studentRow.grade}-${teacher.last_name}`: classInfo.name
          })))
        )
        //.groupBy((group) => group.teacher.id)
        
        .groupBy((group) => group.classInfo)
        .values()
        .map((studentRows) =>  
          studentRows.map((studentRow) => 
          ({
            teacher: studentRow.teacher,
            grade: studentRow.grade,
            students: studentRows.flatMap((sr) => sr.student),
            classInfo: studentRow.classInfo
          })

        ))
        .sortBy((group) => group.map((gr)=> gr.classInfo))
        .value();
          
        return studentGroupRow.flat(1);
    }
    return [];
  }, [classWideNeedsData]);

  let groups: evidenceColumnGroup[] = useMemo(() => {
    const groupArray: evidenceColumnGroup[] = [];
    for (let i = 0; i < evidenceGroups.length; i++) {
      const group = evidenceGroups[i];
      if(!groupArray.some((data:evidenceColumnGroup)=> (data.grade == group.grade) && (data.teacher.id == group.teacher.id) && (data.teacher.classes != null) &&(data.teacher.classes[0].name == group.classInfo))) {

        const groupSt = group.students.filter((student)=> student.teachers?.find((st)=> (st.id == group.teacher.id)))

        const groupObj: evidenceColumnGroup = {
          grade: group.grade,
          students: Array.from( new Set(groupSt)),
          teacher: group.teacher,
          classInfo: group.classInfo
        }
        
        groupArray.push(groupObj);
      }
    }
    return groupArray;
    // groups.map((group)=> {
    //   if(!groupArray.some((data:any)=> (data.grade == group.grade) && (data.teacher.id == group.teacher.id) && (data.teacher.classes != null) &&(data.teacher.classes[0].name == group.classInfo))) {
  
    //     const groupSt = group.students.filter((student)=> student.teachers?.find((st)=> (st.id == group.teacher.id)))
        
    //     const groupObj = {
    //       grade: group.grade,
    //       students: Array.from( new Set(groupSt)),
    //       teacher: group.teacher,
    //       classInfo: group.classInfo
    //     }
        
    //     return groupArray.push(groupObj);
    //   }
    // })
  
    // groups = [...groupArray];

  },[evidenceGroups])



  const allStudentsIdsWithBelowOrWellBelowByArea = useMemo(() => {
    if (classWideNeedsData?.evidence_column_groups) {
      return _.chain(classWideNeedsData.evidence_column_groups)
        .filter((ecg) => ecg.is_behaviour_primary_screening === true)
        .flatMap((ecg) => ecg.evidence_columns)
        .filter(
          (ecg) =>
            ecg.evidence_type === EvidenceType.Data &&
            ecg.measurement.type !== MeasurementType.CATEGORY &&
            ecg.measurement.skill_areas!.length > 0
        )
        .reduce<{ studentId: number; areas: (string | undefined)[] }[]>(
          (prevEcg, ecg) => {
            const studentsIdsWithBelowOrWellBelow:any = ecg.student_entries.reduce<
              {
                studentId: number;
                areas: (string | undefined)[];
              }[]
            >((prevEc, se) => {
              const colorCriteriaList =
                timePeriod &&
                se.grade &&
                ecg.measurement.grade_specific_color_criteria &&
                ecg.measurement.grade_specific_color_criteria[se.grade]?.[
                timePeriod
                ];

              if (colorCriteriaList && se.value !== undefined) {
                const value: number = +se.value;
                const colorCriteria = colorCriteriaList.find(
                  (cc) => {
                    if (cc) {
                      return value >= +cc.range_min! && value <= +cc.range_max!
                    }
                  }
                );

                
                if (
                  colorCriteria &&
                  (colorCriteria.benchmark_status === "well_below" ||
                  colorCriteria.benchmark_status === "below")
                  ) {

                  return [
                    ...prevEc,
                    {
                      studentId: se.student_id,
                      areas:
                        ecg.measurement.skill_areas?.map(
                          (sa) => SkillAreaGroup[sa]
                        ) ?? [],
                    },
                  ];
                }
              }

              return prevEc;
            }, []);
            return [...prevEcg, ...studentsIdsWithBelowOrWellBelow];
          },
          []
        )
        .flatMap((g) =>
          g.areas.map((a) => ({ area: a, studentId: g.studentId }))
        )
        .groupBy((g) => g.area)
        .values()
        .reduce<ClassWideNeed>(
          (pV, cV) => {
            const area: keyof ClassWideNeed = cV[0].area as any;
            return {
              ...pV,
              [area]: {
                ...pV[area],
                studentsIds: _.chain(cV)
                  .map((a) => a.studentId)
                  .uniq()
                  .value(),
              },
            };
          },
          {
            self_awareness: {
              skills:[],
              studentsIds:[]
            },
            self_management: {
              skills:[],
              studentsIds:[]
            },
            social_awareness: {
              skills:[],
              studentsIds:[]
            },
            relationship_skills: {
              skills:[],
              studentsIds:[]
            },
            goal_directed_behavior: {
              skills:[],
              studentsIds:[]
            },
            personal_responsibility: {
              skills:[],
              studentsIds:[]
            },
            decision_making: {
              skills:[],
              studentsIds:[]
            },
            optimistic_thinking: {
              skills:[],
              studentsIds:[]
            }
          }
        )
        .value();
    }
    return {
      self_awareness: {
        skills:[],
        studentsIds:[]
      },
      self_management: {
        skills:[],
        studentsIds:[]
      },
      social_awareness: {
        skills:[],
        studentsIds:[]
      },
      relationship_skills: {
        skills:[],
        studentsIds:[]
      },
      goal_directed_behavior: {
        skills:[],
        studentsIds:[]
      },
      personal_responsibility: {
        skills:[],
        studentsIds:[]
      },
      decision_making: {
        skills:[],
        studentsIds:[]
      },
      optimistic_thinking: {
        skills:[],
        studentsIds:[]
      }
    };
  }, [classWideNeedsData?.evidence_column_groups]);


  const evidenceDiagnosticInfoColumn = useMemo(() => {
    if (classWideNeedsData?.evidence_column_groups) {
      return _.chain(classWideNeedsData.evidence_column_groups)
        .flatMap((ecg) => ecg.evidence_columns)
        .find((ec) => ec.evidence_type === EvidenceType.DiagnosticInfo)
        .value();
    }
    return undefined;
  }, [classWideNeedsData?.evidence_column_groups]);


  const classWideNeed = useMemo(() => {
    if (evidenceDiagnosticInfoColumn) {
      return _.chain(evidenceDiagnosticInfoColumn.student_entries)
        .reduce<ClassWideNeed>((prev, se) => {
          if (!se.diagnostic_tags?.length) {
            return prev;
          }

          return se.diagnostic_tags.reduce((prevC, dt) => {
            const groupName: keyof ClassWideNeed =
              dt.area && (SkillAreaGroup[dt.area] as any);

            if (groupName) {
              return {
                ...prevC,
                [groupName]: prevC[groupName].skills.some(
                  (g) => g.skill_focus === dt.skill_focus
                )
                  ? {
                    ...prevC[groupName],
                    skills: prevC[groupName].skills.map((g) =>
                      g.skill_focus === dt.skill_focus
                        ? {
                          ...g,
                          studentIds: _.union(g.studentIds, [
                            se.student_id,
                          ]),
                        }
                        : g
                    ),
                  }
                  : {
                    ...prevC[groupName],
                    skills: [
                      ...prevC[groupName].skills,
                      {
                        skill_focus: dt.skill_focus,
                        display_name: dt.display_name,
                        studentIds: [se.student_id],
                      },
                    ],
                  },
              };
            }
            return prevC;
          }, prev);
        }, allStudentsIdsWithBelowOrWellBelowByArea)
        .mapValues((a) => ({
          ...a,
          studentsIds: _.union(
            a.studentsIds,
            a.skills?.flatMap((s) => s.studentIds)
          ),
        }))
        .value();
    }
    return allStudentsIdsWithBelowOrWellBelowByArea;
  }, [allStudentsIdsWithBelowOrWellBelowByArea, evidenceDiagnosticInfoColumn]);

  const behaviorStats = useMemo(() => {
    return groups
      .map((group:evidenceColumnGroup) => {
        return {
          ...group,
          classWideNeed: _.chain(classWideNeed)
            .mapValues((skillAreaStats) => {
              return {
                studentsIds: skillAreaStats.studentsIds.filter((id) =>
                  group.students.some((s: Student) => s.id === id)
                ),
                skills: skillAreaStats.skills
                  ?.map((ss) => ({
                    ...ss,
                    studentIds: ss.studentIds.filter((id) =>
                      group.students.some((s: Student) => s.id === id)
                    ),
                  }))
                  .filter((s) => s.studentIds.length),
              };
            })
            .entries()
            .filter(
              ([key, skillAreaStat]) =>
                skillAreaStat.studentsIds.length >=
                group.students.length * BREAKPOINT
            )
            .fromPairs()
            .value(),
        };
      })
      .filter((group:any) =>
        Object.entries(group.classWideNeed).some(
          ([key, list]) =>
            (list as any).studentsIds.length >= group.students.length * BREAKPOINT
        )
      );
  }, [groups, classWideNeed]);

  return {
    behaviorStats,
  };
};

export default useBehaviourClassWideNeeds;
